import {
  Backdrop,
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Fade,
  Grid,
  Modal,
  Typography,
  Button,
  Checkbox,
  Tooltip,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

import "./OrderQueueCard.css";
import imageCross from "./../../../../assets/icons/cross.png";
import axios from "axios";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import closeIcon from "./../../../../assets/icons/close.png";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import { toast, ToastContainer } from "react-toastify";
import { Padding } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const OrderQueueCard = (props) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [currentStatus, setCurrentStatus] = useState(0);
  const [selectedItem, setSelectedItem] = useState(false);
  const [cencalationReasons, setCencalationReasons] = useState(false);
  const [selectCencalationReason, setSelectCencalationReason] = useState(false);
  const [remarks, setRemarks] = useState("N/A");

  const [orderPricingData, setOrderPricingData] = useState(null);
  const [constructedRefundItem, setConstructedRefundItem] = useState(null);

  const orderId = props.orderId;

  useEffect(() => {
    switch (props.from) {
      case "Ready":
        setCurrentStatus(7);
      case "Pending":
        setCurrentStatus(5);
      case "Preparing":
        setCurrentStatus(6);
      case "Queue":
        setCurrentStatus(1);
    }
  }, []);

  const loadCancelationReasons = async () => {
    await axios
      .get(`${process.env.REACT_APP_SECRET}/api/OrderCancelationReason`)
      .then((res) => {
        var list = [];
        res.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.cancelationReason,
          };
          list.push(obj);
        });
        setCencalationReasons(list);
      });
  };

  const handleCancelItem = async (item) => {
    setSelectedItem(item);

    console.log("O111: ", orderId);

    try {
      // 1. Fetch Pricing Details from API
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/OrderRefund/GetOrderPricingDetails/${props.orderId}`,
      );

      if (response.data && response.data.length > 0) {
        const pricingInfo = response.data[0];
        setOrderPricingData(pricingInfo);

        // 2. Build the Payload using our helper function
        const payload = buildRefundItemPayload(item, pricingInfo);

        if (payload) {
          setConstructedRefundItem(payload);

          // 3. CONSOLE LOG FOR VERIFICATION (THIS IS THE MOST IMPORTANT PART)
          // console.log("--- GENERATED REFUND ITEM OBJECT ---");
          // console.log(JSON.stringify(payload, null, 2));
          // console.log("---------------------------------------");
        } else {
          toast.error("Could not match item pricing details.");
          return;
        }
      }

      // 4. Open the modal only after data is ready
      await loadCancelationReasons();
      handleOpen();
    } catch (error) {
      console.error("Error fetching pricing details:", error);
      toast.error("Failed to load refund details.");
    }
  };

  // Helper function to build the specific refund payload
  const buildRefundItemPayload = (item, pricingData) => {
    // Find the specific item in the API response that matches our selected item ID
    const matchedPricing = pricingData.refundItems?.find(
      (p) => p.orderItemId === item.id,
    );

    if (!matchedPricing) {
      console.error("Error: Could not find pricing data for item ID:", item.id);
      return null;
    }

    // Calculate Total Price (Base + VAT + SD) * Quantity
    const unitTotal =
      (item.basePrice || 0) + (item.vatInAmount || 0) + (item.sdInAmount || 0);
    const calculatedTotalPrice = unitTotal * (item.qty || 1);

    // D. Map Addons (Loop through addons and match their pricing too)
    const mappedAddons = item.orderAddons?.map((addon) => {
      // Find matching addon pricing from API
      const matchedAddonPricing = matchedPricing.addOns?.find(
        (a) => a.addOnId === addon.addOnId,
      );

      // Map Options inside Addons
      const mappedOptions = addon.orderOptions?.map((option) => {
        // Map SubOptions inside Options
        const mappedSubOptions = option.orderSubOptions?.map((subOption) => ({
          subOptionId: subOption.subOptionId,
          subOptionPrice: subOption.totalPrice,
          subOptionQty: subOption.qty,
        }));

        return {
          optionId: option.optionId,
          optionPrice: option.totalPrice,
          optionQty: option.qty,
          subOptions:
            mappedSubOptions && mappedSubOptions.length > 0
              ? mappedSubOptions
              : null,
        };
      });

      return {
        addOnId: addon.addOnId,
        addOnPrice: addon.totalPrice,
        // Inject Financial Data from API here
        AddOnTipsAmount: matchedAddonPricing?.addOnTipsAmount || 0,
        AddOnServiceChargeAmount:
          matchedAddonPricing?.addOnServiceChargeAmount || 0,
        AddOnServiceChargeVatAmount:
          matchedAddonPricing?.addOnServiceChargeVatAmount || 0,
        addOnQuantity: addon.qty,
        options:
          mappedOptions && mappedOptions.length > 0 ? mappedOptions : null,
      };
    });

    // Construct the Final Object
    return {
      orderItemId: item.id,
      totalPrice: calculatedTotalPrice.toFixed(2),
      tipsAmount: matchedPricing.tipsAmount || 0,
      serviceChargeAmount: matchedPricing.serviceChargeAmount || 0,
      ServiceChargeVatAmount: matchedPricing.serviceChargeVatAmount || 0, // Note the capital 'S'
      quantity: item.qty,
      initialQuantity: item.qty,
      addOns: mappedAddons && mappedAddons.length > 0 ? mappedAddons : [],
    };
  };

  const handleCancelOrder = async () => {
    if (!constructedRefundItem || !selectedItem) {
      toast.error("Refund data not ready. Please try again.");
      return;
    }

    // Get Creator ID from Token
    let creatorId = "";
    try {
      const token = localStorage.getItem("gotasteadmintoken");
      if (token) {
        const decoded = jwt_decode(token); // or jwtDecode depending on your import
        creatorId = decoded.UserId;
      } else {
        toast.error("User token not found.");
        return;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      toast.error("Invalid user session.");
      return;
    }

    // Update Item Status to Canceled
    const cancelObj = {
      id: "string",
      orderItemId: selectedItem.id,
      statusId: "IS006",
      isRefunded: true,
      cancelationReasonId:
        selectCencalationReason?.id !== undefined
          ? selectCencalationReason.id
          : "CR007",
      cancelationReason:
        selectCencalationReason?.title !== undefined
          ? selectCencalationReason.title
          : "Not Provided",
      remarks: remarks,
      restaurantId: props.restaurantId,
    };

    try {
      // Call the CancelOrderItem API FIRST
      await axios.post(
        `${process.env.REACT_APP_SECRET}/api/Order/CancelOrderItemForKitchen`,
        cancelObj,
      );

      toast.success("Item status updated to Canceled", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });

      // Process the Refund (Only if Step A succeeded)
      const refundPayload = {
        orderPaymentId: orderPricingData?.orderPaymentId || "",
        orderStatus: "Transaction/PartialRefund",
        refundTypeId: "2",
        refundFromOrderId: "",
        refundAmount: constructedRefundItem.totalPrice,
        refundReasonDescription:
          selectCencalationReason?.title || "Not Provided",
        creatorId: creatorId,
        refundItems: [constructedRefundItem],
        processingType: "Bank",
        emailAddress: "demoEmail",
        refundStatus: "RS002",
      };

      // console.log(
      //   "Sending Partial Refund Payload:",
      //   JSON.stringify(refundPayload, null, 2),
      // );

      const refundResponse = await axios.post(
        `${process.env.REACT_APP_SECRET}/api/OrderRefund/OrderPartialRefund`,
        refundPayload,
        { headers: { "Content-Type": "application/json" } },
      );

      const message = refundResponse.data;

      // Handle Refund Response
      if (
        message.includes("Successfull") ||
        message.includes("Successful") ||
        message.includes("Partial Refund")
      ) {
        toast.success("Refund processed successfully!", {
          position: "top-right",
          autoClose: 5000,
          theme: "colored",
        });

        handleClose();
        props.reload(); // Refresh the parent list
      } else if (message.includes("already")) {
        toast.error(message);
      } else {
        toast.warning(message);
      }
    } catch (error) {
      console.error("Error during cancellation/refund:", error);

      // Determine which step failed
      if (error.response?.config?.url?.includes("CancelOrderItem")) {
        toast.error(
          "Failed to cancel item status: " +
            (error.response?.data || error.message),
        );
      } else if (error.response?.config?.url?.includes("OrderPartialRefund")) {
        toast.error(
          "Item canceled, but refund failed: " +
            (error.response?.data || error.message),
        );
        // Note: The item is already canceled in DB, but money wasn't refunded. You might need manual intervention here.
        props.reload(); // Still reload to show the canceled status
      } else {
        toast.error("An unexpected error occurred: " + error.message);
      }
    }
  };

  const handleStatusChange = async (isChecked, selectedItemId) => {
    var obj = {
      id: "string",
      orderItemId: selectedItemId,
      statusId: isChecked ? "IS007" : "IS008",
      restaurantId: props.restaurantId,
    };
    await axios
      .post(`${process.env.REACT_APP_SECRET}/api/Order/ChangeOrderStatus`, obj)
      .then((res) => {
        toast.success("Item Status Changed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        props.reload();
      });

    // if (props.from == "Preparing") {
    //   handleStatusChange(
    //     !props.ItemDetails.isReady,
    //     props.ItemDetails.id
    //   );}
  };
  const truncateItemName = (name: any) => {
    return name.length > 38 ? `${name.substring(0, 38)}...` : name;
  };

  const showAllergyInfo = (() => {
    try {
      const restaurant = JSON.parse(localStorage.getItem("restaurant") || "{}");
      return restaurant?.ulsHLfS === true;
    } catch {
      return false;
    }
  })();

  return (
    <>
      <ToastContainer />
      {/* FoodItems Detail Section */}
      <div
        className="row"
        title={
          props.from === "Preparing"
            ? "dblclick to send to ready"
            : "dblclick to send back to preparing"
        }
        style={{
          padding: "10px",
          backgroundColor: props.ItemDetails.isReady ? "#66bb6a" : "initial",
          cursor: "pointer",
        }}
        onDoubleClick={() => {
          if (props.from === "Preparing") {
            handleStatusChange(
              !props.ItemDetails.isReady,
              props.ItemDetails.id,
            );
          } else if (props.from === "Ready") {
            handleStatusChange(
              !props.ItemDetails.isReady,
              props.ItemDetails.id,
            );
          }
        }}
      >
        <div className="col-10 d-flex justify-content-start align-items-center">
          <Tooltip title={props.ItemDetails.itemName} arrow>
            <Typography
              className="orderQueueCardItemName"
              sx={{
                color: props.ItemDetails.isReady ? "white !important" : "black",
              }}
            >
              {props.index + 1}.{" "}
              {props.fromData === "Modal"
                ? props.ItemDetails.itemName
                : truncateItemName(props.ItemDetails.itemName)}
            </Typography>
          </Tooltip>
        </div>

        <div className=" col-2 d-flex justify-content-end align-items-center orderQty">
          <Typography
            className="orderQueueCardItemlast"
            sx={{
              color: props.ItemDetails.isReady ? "white !important" : "black",
            }}
          >
            x{props.ItemDetails.qty}
          </Typography>
          {props.from !== "Ready" && (
            <img
              src={imageCross}
              className="crossImage"
              alt="cross icon"
              onClick={() => {
                handleCancelItem(props.ItemDetails);
                console.log("Cross Clicked", JSON.stringify(props.ItemDetails));
                console.log("Order ID: ", props.orderId);
              }}
            />
          )}
          {props.isWaitersView === false &&
            (props.from === "Preparing" || props.from === "Ready") && (
              <Checkbox
                style={{ padding: "2px" }}
                color={props.ItemDetails.isReady ? "default" : "success"}
                checked={props.ItemDetails.isReady}
                onChange={(event) => {
                  handleStatusChange(
                    event.target.checked,
                    props.ItemDetails.id,
                  );
                }}
              />
            )}
          {/* {props.ItemDetails.isReady && props.from != "Preparing" && (
            <Checkbox
              color={props.ItemDetails.isReady ? "default" : "success"}
              checked={props.ItemDetails.isReady}
              onChange={(event) => {
                handleStatusChange(event.target.checked, props.ItemDetails.id);
              }}
            />
          )} */}
        </div>
        {/* AddOns Mapping */}
        {props.ItemDetails.orderAddons?.length > 0 &&
          props.ItemDetails.orderAddons?.map((addOn, i) => (
            <div className="col-12 d-flex flex-wrap">
              <span
                className="orderQueueCardAddOnName"
                style={{
                  color: props.ItemDetails.isReady
                    ? "white !important"
                    : "black",
                }}
              >
                {addOn?.addOnName} x{addOn?.qty}
              </span>
              {/* Option Mapping */}

              {addOn?.orderOptions?.map((item, idx) => (
                <span key={idx} className="orderQueueCardAddOnName">
                  <span style={{ fontSize: "14px" }}>• </span>
                  {item?.optionName} x{item?.qty}
                </span>
              ))}
              {/* SubOption Mapping  */}
              {addOn?.orderOptions?.map((item, idx) =>
                item?.orderSubOptions?.map((subOption, subIdx) => (
                  <span className="orderQueueCardAddOnName" key={subIdx}>
                    <span style={{ fontSize: "14px" }}>• </span>
                    {subOption.subOptionName}
                  </span>
                )),
              )}
            </div>
          ))}
        <div className="col-12 orderQueueCardMeta" style={{paddingTop:"10px"}}>
          <div
            className={`orderQueueCardInstructionsCard ${
              props.ItemDetails.isReady
                ? "orderQueueCardInstructionsCard--ready"
                : ""
            }`}
          >
            <span className="orderQueueCardMetaEyebrow">Instructions</span>
            <p className="orderQueueCardInstructionsText">
              {props.ItemDetails.instructions || "N/A"}
            </p>
          </div>

          {showAllergyInfo && (
            <div
              className={`orderQueueCardAllergyCard ${
                props.ItemDetails.isReady
                  ? "orderQueueCardAllergyCard--ready"
                  : ""
              }`}
            >
              <div className="orderQueueCardAllergyHeader">
                <WarningAmberRoundedIcon className="orderQueueCardAllergyIcon" />
                <p className="orderQueueCardAllergyConfirmed">
                  <strong>Allergy confirmed:</strong>{" "}
                  <span
                    className={
                      props.ItemDetails.isNoAllergyConfirmation
                        ? "orderQueueCardAllergyStatus--yes"
                        : "orderQueueCardAllergyStatus--no"
                    }
                  >
                    {props.ItemDetails.isNoAllergyConfirmation ? "Yes" : "No"}
                  </span>
                </p>
              </div>
              <span className="orderQueueCardMetaEyebrow orderQueueCardMetaEyebrow--allergy">
                Allergy note
              </span>
              <p className="orderQueueCardAllergyNoteText">
                {props.ItemDetails.noAllergyConfirmationNote || "—"}
              </p>
            </div>
          )}
        </div>
      </div>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              ...style,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>GoTaste:- Cancel Items</h5>
              <Button onClick={handleClose}>
                <img src={closeIcon} style={{ width: "1rem" }} />
              </Button>
            </div>
            <br />
            <Grid container>
              <Grid
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  marginTop: ".8rem",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                <Typography sx={{ marginBottom: ".5rem" }}>
                  Item Name:
                </Typography>
              </Grid>
              <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                <Typography>
                  <strong>
                    {selectedItem.itemName} X {selectedItem.qty}
                  </strong>
                </Typography>
              </Grid>
              <Grid
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  marginTop: ".8rem",
                  alignItems: "start",
                  justifyContent: "start",
                }}
              >
                <Typography sx={{ marginBottom: ".5rem" }}>Add Ons:</Typography>
              </Grid>
              <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                {selectedItem.orderAddons?.length > 0 ? (
                  selectedItem.orderAddons?.map((option, i) => (
                    <Typography className="">
                      {option.addOnName} x {option.qty}
                    </Typography>
                  ))
                ) : (
                  <Typography>N/A</Typography>
                )}
              </Grid>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <AutoCompleteMultiSelect
                  id={33}
                  placeholder={"Select Cancelation Reason (Optional)"}
                  datas={cencalationReasons}
                  value={(res) => {
                    setSelectCencalationReason(res);
                  }}
                />
              </Grid>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <TextAreaComponents
                  id={1}
                  value={(res) => {
                    setRemarks(res);
                    console.log("remarks", remarks);
                  }}
                  label={"Remarks (Optional)"}
                />
              </Grid>
              <Grid
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px",
                  marginTop: "1rem",
                }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => {
                    handleCancelOrder();
                  }}
                >
                  Cancel Item
                </Button>
                <Button variant="outlined" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default OrderQueueCard;
